// ─── Types (place with your other invoice request/response types) ────────────

import ApiConfig from "../../Utils/Configs/apiConfig";

export interface BulkEditInvoiceRequest {
  invoiceIds: number[];
  businessClientId: string;
  screen: string;

  type?: string;
  invoiceDate?: string;
  supplier?: string;
  supplierId?: number;
  category?: string;
  categoryId?: number;
  description?: string;
  currency?: string;
  paid?: string;
  paymentMethod?: string;
  payment?: number;
  rowVersions?: Record<number, string>
}

export interface BulkEditFailedItem {
  id: number;
  reason?: string;
}

export interface BulkEditInvoiceResponse {
  updatedIds: number[];
  failed: BulkEditFailedItem[];
}

// ─── Service ─────────────────────────────────────────────────────────────────

export const BulkEditInvoicesService = async (
  request: BulkEditInvoiceRequest
): Promise<BulkEditInvoiceResponse> => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/Invoice/BulkEditInvoices",
      request
    );

    // Backend wraps in ServiceResult envelope: { status, data, message }
    const data = response.data?.data ?? response.data;

    // Normalise casing (camelCase / PascalCase) and guarantee arrays,
    // so the UI never has to null-check.
    const updatedIds: number[] = data?.updatedIds ?? data?.UpdatedIds ?? [];
    const rawFailed: any[] = data?.failed ?? data?.Failed ?? [];

    return {
      updatedIds,
      failed: rawFailed.map((f) => ({
        id: f?.id ?? f?.Id ?? f?.invoiceId ?? f?.InvoiceId,
        reason: f?.reason ?? f?.Reason,
      })),
    };
  } catch (error: any) {
    console.error("Error in BulkEditInvoicesService", error);

    const wrapped: any = new Error(
      error?.response?.data?.message ??
      error?.response?.data?.Message ??
      "Failed to bulk edit invoices"
    );
    wrapped.status = error?.response?.status;
    throw wrapped;
  }
};